import { ACTIVITY_ID_PARAM, PROFILE_IDS_PARAM } from "PFApp/profiles/cv_exports/cv_exports_page.consts";
import { Id } from "PFTypes";

export const getCvExportsPath = (profileIds: Id[], activityId?: Id) => {
  const params = new URLSearchParams();
  params.set(PROFILE_IDS_PARAM, profileIds.join(","));
  if (activityId) {
    params.set(ACTIVITY_ID_PARAM, String(activityId));
  }
  return `/profiles/cv_exports?${params.toString()}`;
};
